import React from 'react';
import { createPortal } from 'react-dom';
import './SpamAlertModal.css';

const SpamAlertModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="spam-alert-overlay">
      <div className="spam-alert-modal" onClick={(e) => e.stopPropagation()}>
        <div className="spam-alert-content">
          <h2>⚠️ Question Validation</h2>
          <p>
            Your questions don't seem to be relevant to the book. To save API quota, 
            we're pausing your ability to ask questions for 24 hours.
          </p>
          <p className="spam-alert-note">
            Please make sure your questions are about the book you're viewing.
          </p>
          <button className="btn btn-primary" onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default SpamAlertModal;
